import { Autocomplete, Icon, BlockStack, Text, Divider, Box, InlineStack, Button, Link } from '@shopify/polaris';
import React, { ReactElement, useCallback, useState } from 'react';
import { DI } from '../../../../Core';
import { SearchMinor } from '@shopify/polaris-icons';
import { accont_connection_list, amazon_regions_onboarding } from './onboardinghelper';
import { IndicateIcon } from '../../../../Asests/svgIcon/icon';
import { useTranslation } from 'react-i18next';

function Stepone(props: any): ReactElement {
    const { t } = useTranslation();
    const { accont_connection_list_opt } = accont_connection_list();
    const deselectedOptions = amazon_regions_onboarding(t);
    const [selectedOptions, setSelectedOptions] = useState<any>([]);
    const [inputValue, setInputValue] = useState<any>('');
    const [options, setOptions] = useState<any>(deselectedOptions);

    const updateSelection = useCallback((selected: any[]) => {
        const selectedValue = selected.map((selectedItem) => {
            const matchedOption = options.find((option: { value: string; }) => {
                return option.value.match(selectedItem);
            });
            return { label: matchedOption.label, "marketplace_id": matchedOption.marketplace_id, region: matchedOption.region }
        });
        setSelectedOptions(selected);
        setInputValue(selectedValue[0]?.['label']);
        props.updateState('region', '', '', selectedValue); //setting state globally
    }, [options]);

    const updateText = useCallback((value: string | RegExp) => {
        setInputValue(value);
        props.updateState('region', '', '', [])
        if (value === '') {
            setOptions(deselectedOptions);
            return;
        }
        const filterRegex = new RegExp(value, 'i');
        const resultOptions = deselectedOptions.filter((option) => {
            if (!option?.hasOwnProperty("disabled") && option?.disabled !== true)
                return option.label.match(filterRegex);
        });
        setOptions(resultOptions);
        props.updateState('region_text', '', '', value)
    }, [deselectedOptions]);

    const textField = (
        <Autocomplete.TextField
            onChange={(value) => updateText(value.replace(/[0-9-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, ''))}
            label={t("Country")}
            value={inputValue}
            prefix={<Icon source={SearchMinor} tone="base" />}
            placeholder={t("Search")}
            autoComplete='off'
            error={props.errors.region && t('Kindly select your country')}
            requiredIndicator
        />
    );

    const renderFeatures = (region: string) => {
        switch (region) {
            case "EU":
                return (
                    <BlockStack gap="100">
                        {
                            accont_connection_list_opt.slice(0, 2).map((list: any, index: number) => {
                                return (
                                    <InlineStack gap="200" wrap={false} key={index}>
                                        <div>{IndicateIcon}</div>
                                        <Text as="p">{list?.label}</Text>
                                    </InlineStack>
                                );
                            })
                        }
                    </BlockStack>
                );
            default:
                return (
                    <BlockStack gap="100">
                        {
                            accont_connection_list_opt.map((list: any, index: number) => {
                                return (
                                    <InlineStack gap="200" wrap={false} key={index}>
                                        <div>{IndicateIcon}</div>
                                        <Text as="p">{list?.label}</Text>
                                    </InlineStack>
                                );
                            })
                        }
                    </BlockStack>
                );
        }
    }

    return (
        <BlockStack gap="500">
            <BlockStack gap="200">
                <Text as="h2" variant="headingMd">
                    {t("Step")}{' '}
                    <Text as="span">
                        {props.steps_completed + 1}
                        <Text as="span" tone="subdued">/3{' '}</Text>
                    </Text>{' '}
                    : {t("Connect Amazon Account")}
                </Text>
                <Text as="p" tone='subdued'>{t("Pick the country where you're selling in and connect your Amazon account for that country. If you want, you can link more than one Amazon account using the app.")}{' '}</Text>
            </BlockStack>
            <Divider />
            <BlockStack gap="300">
                <Autocomplete options={options} selected={selectedOptions} onSelect={updateSelection} textField={textField} />
                {/* suggestion  */}
                {
                    selectedOptions?.length !== 0 && inputValue !== "" &&
                    <Box padding="500" background="bg" borderRadius="100">
                        <BlockStack gap="300">
                            <Text as="p" fontWeight="semibold">{t("Before proceeding, make sure you have these in place:")}</Text>
                            <BlockStack gap="100">
                                {
                                    amazon_regions_onboarding(t).filter((key: any) => key?.region && key?.value === selectedOptions[0]).length !== 0 &&
                                    renderFeatures(amazon_regions_onboarding(t).filter((key: any) => key?.region && key?.value === selectedOptions[0])[0]?.region)
                                }
                            </BlockStack>
                        </BlockStack>
                    </Box>
                }
                <Button
                    loading={props?.isLoading()}
                    onClick={() => { props?.onSave() }}
                    disabled={selectedOptions?.length == 0 && inputValue === "" && props?.['steps_completed'] == 0 ? true : false}
                    variant="primary"
                >
                    {props?.getFooterActionText()}
                </Button>
                <InlineStack gap="100" align="center">
                    <Text as="p" tone="subdued">{t("By using our services, you agree to our")}</Text>
                    <Link url="https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf" target='_blank'>{t("terms & conditions")}</Link>
                    {t("and")}
                    <Link url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf' target='_blank'>{t("data privacy rights")}</Link>
                </InlineStack>
            </BlockStack>
        </BlockStack>
    );
}

export default DI(Stepone);